(function() {
	'use strict';

	angular
		.module('humbertContainer',[
			'ui.router',
			'monospaced.elastic',
			'angular-loading-bar'
		])
		.constant('_', window._);

})();